import { createContext } from 'react';

const FLEX_WINDOW_KEY = "__FLEX__";
const FLEX_WINDOW_GLOBAL_CONTEXTS_KEY = "global-contexts";
const createGlobalReferenceContext = (key, initialValue) => {
  if (typeof window === "undefined") {
    return createContext(initialValue);
  }
  if (window?.[FLEX_WINDOW_KEY]?.[FLEX_WINDOW_GLOBAL_CONTEXTS_KEY] === void 0) {
    window[FLEX_WINDOW_KEY] = {
      ...window?.[FLEX_WINDOW_KEY] || {},
      [FLEX_WINDOW_GLOBAL_CONTEXTS_KEY]: {}
    };
  }
  const globalContexts = window?.[FLEX_WINDOW_KEY]?.[FLEX_WINDOW_GLOBAL_CONTEXTS_KEY] ?? {};
  return globalContexts?.[key] ?? (globalContexts[key] = createContext(initialValue));
};

export { createGlobalReferenceContext };
//# sourceMappingURL=createGlobalReferenceContext.mjs.map
